import React from 'react';
import {connect} from "react-redux";
import {ErrorBoundary} from "./error-boundary";
import canUseDOM from '../../utils/can-use-dom';

const getHtml = (widgetTemplate = '') => ({__html: widgetTemplate});

const getConcatinatedWidgets = (widgets = []) => widgets.reduce((accumulator, currentElement) => {
  const template = currentElement.template || '';
  const decoded = canUseDOM ? atob(template) : Buffer.from(template, 'base64').toString('binary');
  return accumulator + decoded;
},'');

const InjectWidgetBase = (props) => {
  let decodedValue = '';
  if(props.publisherTheme.widgets && props.publisherTheme.widgets.constructor === Array){
    decodedValue = props.publisherTheme.widgets ? getConcatinatedWidgets(props.publisherTheme.widgets) : '';
  } else {
    decodedValue = canUseDOM ? atob( props.publisherTheme.widgets || '') : Buffer.from( props.publisherTheme.widgets || '', 'base64').toString('binary');
  }
  if(!decodedValue) return null;
  return (
    <ErrorBoundary>
      <div dangerouslySetInnerHTML={getHtml(decodedValue)}></div>
    </ErrorBoundary>
  );
};

function mapStateToProps(state) {
  return {
    publisherTheme: state.qt.config['theme-attributes'] || {},
  }
}

export const InjectWidget = connect(mapStateToProps, () => ({}))(InjectWidgetBase);
